<template>
  <div class="pa-6">
    <Loader :messageSelector="messageSelector" :overlay="overlay" />
    <v-form ref="form" v-model="valid">
      <!-- Activités -->
      <fieldset>
        <legend class="text-h6 text-sm-h5">Activités réservées</legend>
        <div class="legalSection">
          <RessourceInfoBulle code="UNI-AR-2" />

          <v-list flat subheader>
            <v-list-item-group>
              <list-item-with-checkbox
                v-for="fd in activitesReservees"
                v-bind:key="fd.id"
                :value="fd.value"
                :texte="fd.lang00"
                :disabled="fd.disabled"
                :property-name="fd.id.toString()"
                @updateChoix="updateChoix"
              />
            </v-list-item-group>
          </v-list>
          <v-input :value="this.activitesReservees.filter((ar) => ar.value)" :rules="rules.activitesReserveesCompletion"></v-input>
        </div>
        <div v-if="isEvaluationAdoptionEnfant">
          <p class="mentionLegal font-weight-bold">
            Exercez-vous cette activité auprès de personnes voulant adopter hors Québec?
          </p>
          <v-autocomplete
            v-model="getActiviteReservee.activiteAdoptionHorsQuebec"
            :item-text="itemText"
            :item-value="itemValue"
            :items="listeActiviteAdoptionHorsQuebec"
            :rules="rules.activiteAdoptionHorsQuebec"
            class="cssRequired"
            label="Réponse"
            required
            return-object
          ></v-autocomplete>
        </div>
      </fieldset>
    </v-form>

    <!-- Buttons -->
    <div class="text-right">
      <v-btn color="primary" :disabled="!valid" @click="saveAndExit()">Sauvegarder et fermer</v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import Loader from "../Loader"
import ListItemWithCheckbox from "../common/ListItemWithCheckbox"
import { getExtranetUrl } from "@/utils/stringUtils"

export default {
  props: {
    routeName: {
      type: String,
      default: "",
    },
  },
  components: {
    Loader: Loader,
    ListItemWithCheckbox,
  },
  data() {
    return {
      messageSelector: "",
      overlay: false,
      valid: false,
      activitesReservees: [],
      rules: {
        activiteAdoptionHorsQuebec: [(v) => !!v || "Cette valeur est requise"],
        activitesReserveesCompletion: [
          () => this.activitesReservees.filter((ar) => ar.value).length > 0 || "Vous devez sélectionner au moins une valeur",
        ],
      },
    }
  },
  computed: {
    ...mapGetters({
      contactId: "Unitaire/GET_CONTACTID",
      getActiviteReservee: "ActiviteReservee/getActiviteReservee",
      listeActivitesReservees: "Catalogue/GET_ACTIVITES_RESERVEES",
      listeActiviteAdoptionHorsQuebec: "Catalogue/getActiviteAdoptionHorsQuebec",
    }),
    isEvaluationAdoptionEnfant() {
      return (
        this.activitesReservees
          .find((ar) => ar.id === this.$catalogues.activiteActiviteReserve.evaluationAdoptionEnfant)?.value === true
      )
    },
  },
  created() {
    this.fetchItems()
  },
  methods: {
    ...mapActions({
      getCatalogue: "Catalogue/getCatalogue",
      getActiviteReserveeByContactId: "ActiviteReservee/getActiviteReserveeByContactId",
      createActiviteReservee: "ActiviteReservee/createActiviteReservee",
    }),
    async fetchItems() {
      try {
        this.messageSelector = "Loading"
        this.overlay = true

        const requests = [
          this.getCatalogue(this.$cataloguesDesc.activiteActiviteReserve),
          this.getCatalogue(this.$cataloguesDesc.activiteAdoptionHorsQuebec),
        ]

        if (this.contactId) {
          requests.push(
            this.getActiviteReserveeByContactId(this.contactId).catch((err) => {
              if (err.message.includes("400")) {
                // Cas de la création de la première fiche. todo gérer avec un 404?
              } else {
                this.$router.push({
                  name: "InternalError",
                  params: { message: "Une erreur est survenu au chargement des activités réservées" },
                })
              }
            })
          )
        }

        await Promise.all(requests)

        // définition des coches en fonction du catalogue et des éléments déjà sélectionnés
        let aucuneCoche = false
        this.listeActivitesReservees.forEach((property) => {
          const fd = { ...property }
          fd.value = false

          if (this.getActiviteReservee.activitesReservees?.find((ar) => ar.id === fd.id)) {
            fd.value = true

            if (fd.id === this.$catalogues.activiteActiviteReserve.aucune) {
              aucuneCoche = true
            }
          }

          this.activitesReservees.push(fd)
        })
        this.sanitizeActivitesReservees(aucuneCoche)

        this.validateForm(true)

        this.overlay = false
      } catch (exception) {
        console.log("Exception", exception)
      }
    },
    saveAndExit() {
      this.save()
    },
    async save() {
      this.validateForm()
      if (!(this.valid && this.getActiviteReservee)) {
        return
      }

      this.messageSelector = "Save"
      this.overlay = true

      // set activitesReservees from locale state
      this.getActiviteReservee.activitesReservees = this.activitesReservees.filter((fd) => fd.value)

      if (this.contactId) {
        this.getActiviteReservee.pp = this.contactId
      }

      this.getActiviteReservee.demandeAdmission = null
      this.getActiviteReservee.demandeInscription = null
      await this.createActiviteReservee(this.getActiviteReservee).then(() => {
        this.redirect()
      })
    },
    itemText: (item) => item.lang00,
    itemValue: (item) => item.id,
    updateChoix(payload) {
      const dataId = parseInt(payload.field)
      this.activitesReservees.filter((ar) => ar.id === dataId).forEach((c) => (c.value = payload.choix)) // simplification d'écriture, doit se produire 0 ou 1 fois

      if (dataId === this.$catalogues.activiteActiviteReserve.aucune) {
        this.sanitizeActivitesReservees(payload.choix)
      }

      // vide la précision si la question est masquée
      if (!this.isEvaluationAdoptionEnfant) {
        this.getActiviteReservee.activiteAdoptionHorsQuebec = null
      }
    },
    // assure la cohérence des cases cochées
    sanitizeActivitesReservees(aucuneValue) {
      // aucune pilote la désactivation des autres cases
      this.activitesReservees
        .filter((ar) => ar.id !== this.$catalogues.activiteActiviteReserve.aucune)
        .forEach((c) => (c.disabled = aucuneValue))

      // si coché on veux vider les autres coches
      if (aucuneValue === true) {
        this.activitesReservees.filter((ar) => ar.id !== this.$catalogues.activiteActiviteReserve.aucune).forEach((c) => (c.value = false))
      }
    },
    validateForm(resetValidation = false) {
      this.valid = this.$refs.form?.validate() || false

      if (resetValidation) {
        this.$refs.form?.resetValidation()
      }
    },
    redirect() {
      window.top.location.href = getExtranetUrl(process.env.VUE_APP_PROFIL_XTRANET)
    },
  },
}
</script>

<style scoped></style>